if (!customElements.get('scroll-to-top')) {

  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.scrollThreshold = 300; // Show button after scrolling 300px
      this.handleScroll = this.handleScroll.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.scroll-to-top__button');

      if (!this.button) {
        return;
      }

      this.handleScroll();

      window.addEventListener('scroll', this.handleScroll, { passive: true });

      this.button.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      if (this.button) {
        this.button.removeEventListener('click', this.handleClick);
      }
    }

    handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;

      if (scrollY > this.scrollThreshold) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }

    handleClick(event) {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('scroll-to-top', ScrollToTop);
}

